export default {
    state: {
        menuRouteLoaded: [], 
    },
    getters: {
    },
    mutations: {
        menuRouteLoaded(state, menuRouteLoaded){ 
            state.menuRouteLoaded = menuRouteLoaded
        },  
    },
    actions: {
    }
}